import { LocationDictionaryModel, LocationModel } from '@/lib/models/location/types';
import { RouteLocationApiV2Interface, RouteLocationsApiV2Interface } from '@/types/api-types';

export const transformLocationDictionary = (locations: RouteLocationsApiV2Interface): LocationDictionaryModel => {
  return Object.entries(locations).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: transformLocation(key, value),
    };
  }, {} as LocationDictionaryModel);
};

export const transformLocation = (key: string, location: RouteLocationApiV2Interface): LocationModel => {
  return {
    id: key,
    ...location,
  };
};
